import {
    actionLoading,
    actionSuccess,
    actionErrored,
    actionReset,
} from 'api/helpers'
import { unAuthRequest } from 'api/helpers'
import URL from 'api/endpoints'

// Fetch technologies
export const GET_TECHNOLOGIES = 'GET_TECHNOLOGIES'
export const GET_MORE_TECHNOLOGIES = 'GET_MORE_TECHNOLOGIES'

export const getTechnologiesLoading = actionLoading(GET_TECHNOLOGIES)
export const getTechnologiesSuccess = actionSuccess(GET_TECHNOLOGIES)
export const getTechnologiesErrored = actionErrored(GET_TECHNOLOGIES)
export const getTechnologiesReset = actionReset(GET_TECHNOLOGIES)

export const getMoreTechnologiesSuccess = actionSuccess(GET_MORE_TECHNOLOGIES)

export const getTechnologies = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.technologies + params,
            getTechnologiesLoading,
            getTechnologiesSuccess,
            getTechnologiesErrored
        )
}

export const getMoreTechnologies = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.technologies + params,
            getTechnologiesLoading,
            getMoreTechnologiesSuccess,
            getTechnologiesErrored
        )
}

export const resetTechnologyBrowserState = () => {
    return function (dispatch) {
        dispatch(getTechnologiesReset())
    }
}

// filter technologies
export const FILTER_TECHNOLOGIES = 'FILTER_TECHNOLOGIES'

export const filterTechnologiesLoading = actionLoading(FILTER_TECHNOLOGIES)
export const filterTechnologiesSuccess = actionSuccess(FILTER_TECHNOLOGIES)
export const filterTechnologiesErrored = actionErrored(FILTER_TECHNOLOGIES)

export const filterTechnologies = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.technologies + params,
            null,
            filterTechnologiesSuccess,
            null
        )
}

// Fetch technologies stats
export const GET_TECHNOLOGY_STATS = 'GET_TECHNOLOGY_STATS'

export const getTechnologyStatsLoading = actionLoading(GET_TECHNOLOGY_STATS)
export const getTechnologyStatsSuccess = actionSuccess(GET_TECHNOLOGY_STATS)
export const getTechnologyStatsErrored = actionErrored(GET_TECHNOLOGY_STATS)

export const getTechnologyStats = (params = '') => {
    return (dispatch) =>
        unAuthRequest.get(
            dispatch,
            URL.technology_stats + params,
            getTechnologyStatsLoading,
            getTechnologyStatsSuccess,
            getTechnologyStatsErrored
        )
}
